import UserProfile from "../Context/UserProfile";
import { useEffect, useState } from "react";
const PrivacyPolicy = ({ setUserName,setPageTitle }) => {
    const [displayName, setDisplayName] = useState();
    useEffect(() => {
        setUserName(UserProfile.getName());
        setDisplayName(UserProfile.getName());
        if(UserProfile.getLoginStatus()==="1"){
			setPageTitle("Policy");
		}
    }, [])
	return (
        <>
            <div className={displayName && displayName.length > 0 ? "main-content" : ""}>
                {UserProfile.getLoginStatus()!=="1" && <><header>
						<div className="header-container">
							<div className="logo">
								<a style={{ textDecoration: "none" }} href="/">
									<span style={{ color: 'white' }}>Contr
										<span style={{ color: "#ff8400" }}>e</span>
										ct</span>
								</a>

							</div>
							<nav><a href="/Signup" className="btn btn-success">Sign In</a>
							</nav>
						</div>
					</header>
					<div style={{ paddingTop: '20px', paddingLeft: '100px',paddingBottom:0 }}>
						<h1>Policy</h1>
						<span className="effective-date">Last Updated: 25 Feb 2026</span>
					</div></>}
                <div style={{ marginTop: "5px", textAlign: "left", padding: "100px", paddingTop:"0px", maxHeight: "100%", overflowX: "scroll" }}>
                    <div>
<p>Musedaq Fintech Private Limited {'(“Contrect”, “we”, “us”, or “our”)'} operates the Contrect website {'(www.contrect.com)'}, iOS application, and Android application (collectively, the “Service”).</p>

<p>This Privacy Policy explains how we collect, use, store, and protect your information when you use our Service.</p>

<p>By using Contrect, you agree to this Privacy Policy.</p>

<h4>1. Information We Collect</h4>

<p><strong>A. Personal Information</strong></p>
<ul>
<li>Name</li>
<li>Phone number</li>
<li>Email address</li>
<li>Agreement-related information you provide</li>
</ul>

<p><strong>B. Agreement Data</strong></p>
<p>We collect and store agreement details, documents, and attachments uploaded by users for the purpose of facilitating contract execution between parties.</p>

<p><strong>C. Device Information</strong></p>
<ul>
<li>Device model</li>
<li>Operating system</li>
<li>App version</li>
<li>IP address</li>
<li>Crash logs and diagnostic data</li>
</ul>

<p><strong>D. Camera and Photo Library Access</strong></p>
<p>Our mobile applications may request access to your device’s camera and photo library to allow you to attach images or documents to agreements. We do not access media without your permission.</p>

<p><strong>E. Push Notifications</strong></p>
<p>We may send notifications regarding agreement updates, execution status, and account alerts. You may disable notifications in your device settings at any time.</p>

<p><strong>F. Payment Information</strong></p>
<p>Contrect may facilitate contract-based payments between independent parties. We do not store complete card details. Payments may be processed securely by third-party payment providers.</p>

<div style={{background:'#f0f6ff',
        padding: '10px 15px',
        borderLeft: '4px solid #1f6feb',
        margin: '15px 0'}}>
At present, Contrect does not offer paid digital subscriptions or in-app purchases.
</div>

<h4>2. How We Use Your Information</h4>
<ul>
<li>Provide and maintain the Service</li>
<li>Enable contract creation and execution</li>
<li>Facilitate communication between agreement parties</li>
<li>Improve performance, functionality, and security</li>
<li>Prevent fraud and misuse</li>
<li>Comply with legal obligations</li>
</ul>

<h4>3. Third-Party Services</h4>
<p>We may use trusted third-party providers including cloud hosting services, Firebase (analytics and messaging), and payment processors. These providers process data on our behalf in accordance with their privacy policies.</p>

<h4>4. Account Deletion and Data Retention</h4>

<p>Users may delete their account directly within the Contrect mobile application.</p>

<ul>
<li>The account becomes immediately inaccessible</li>
<li>The user is logged out</li>
<li>Data is scheduled for permanent deletion</li>
</ul>

<p>For security, fraud prevention, and legal compliance purposes, certain data may be retained for up to 30 days before permanent erasure.</p>

<p>After this retention period, personal data is permanently deleted and cannot be restored.</p>

<p>If deletion was made in error, users may contact support within the 30-day retention window.</p>

<h4>5. Data Security</h4>
<p>We implement reasonable technical and organizational safeguards to protect your information. However, no digital transmission or storage method is 100% secure.</p>

<h4>6. Your Rights</h4>
<p>Depending on your jurisdiction, you may have the right to:</p>
<ul>
<li>Access your personal data</li>
<li>Correct inaccurate information</li>
<li>Request deletion of your account</li>
<li>Restrict processing</li>
<li>Request data portability</li>
</ul>

<p>You may exercise these rights via in-app settings or by contacting us.</p>

<h4>7. Children's Privacy</h4>
<p>Contrect is not intended for children under 13 years of age. We do not knowingly collect personal data from children.</p>

<h4>8. International Use</h4>
<p>If you access the Service from outside India, your information may be processed and stored in jurisdictions where our service providers operate.</p>

<h4>9. Changes to This Policy</h4>
<p>We may update this Privacy Policy periodically. Continued use of the Service after updates constitutes acceptance of the revised policy.</p>

                        <h4>10. Contact Us</h4>
                        <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
                        <div>
                            <p>
                                <strong>Musedaq Fintech Private Limited</strong>
                                <br />
                                748/1 Shastri Ward, Babariya,Seoni (MP) -480661
                                <br />
                                Email: <a href="mailto:arpandeepesh@gmail.com">arpandeepesh@gmail.com</a>
                                <br />
                                Phone: +91 8989430555
                            </p>
                        </div>
                    </div>
                </div>
            </div>
		</>
	);
};
export default PrivacyPolicy;